<p [class]="css">
  <a
    *ngIf="internalLink"
    [class.disabled]="!isPermissionAvailable || !isDevicePermissionAvailable"
    [routerLink]="[link]"
    id="cta-default-591"
    >{{ text }}</a
  >
  <a *ngIf="!internalLink" [href]="link" id="cta-default-592">{{ text }}</a>
</p>
